<div *ngIf="themes" fxLayout="column" fxLayoutAlign="start stretch">

  <ng-container *ngIf="themes?.length === 0">
    <mat-card class="contrast">
        <mat-card-content>
            This product is not currently in use by any themes. 
        </mat-card-content>
    </mat-card>
  </ng-container>

  <ng-container *ngFor="let item of themes">

    <a routerLink="/homes/themes/{{ item.companyId }}/{{ item.id }}" routerLinkActive="active">
      <mat-card class="contrast card-link" [class.banner-error]="item.disabled" [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="10px">
              <div fxFlex="80" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="5px">
                  <strong [ngClass.lt-sm]="{'card-title': true}" matTooltip="Select {{ item.name }}">{{ getThemeDisplayName(item) }}</strong>
              </div>

              <div fxFlex="10" fxLayoutAlign="center end" fxLayout="column">
                  <div [matTooltip]="item.dateModified" fxLayoutAlign="center start" fxLayout="column">
                      <small class="text-muted">Last Updated </small>
                      <small>{{ timeAgoString(item.dateModified) }}</small>
                  </div>
              </div>
              <div fxFlex="10" fxLayoutAlign="center end" fxLayout="column">
                  <div [matTooltip]="item.dateLastPublished" fxLayoutAlign="center start" fxLayout="column">
                      <small class="text-muted">Last Published </small>
                      <small>{{ timeAgoString(item.dateLastPublished) }}</small>
                  </div>
              </div>
          </mat-card-content>
      </mat-card>
    </a>

  </ng-container>
</div>